export const workerTypeKeys = {
    all: ['worker-types'] as const,
    types: () => [...workerTypeKeys.all, 'list'] as const,
    type: (id: string) => [...workerTypeKeys.all, 'detail', id] as const,
}
